var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTerminal = function SvgIconTerminal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.25 17a1 1 0 0 1 0 2h-9a1 1 0 1 1 0-2zM3.003 5.336a1 1 0 0 1 1.332-.147l.079.064 6.75 6a1 1 0 0 1 0 1.494l-6.75 6a1 1 0 1 1-1.328-1.494L8.995 12l-5.91-5.253-.072-.071a1 1 0 0 1-.01-1.34"
  })));
};
export default SvgIconTerminal;